import firebase from "firebase";
// Relative Dependencies
import { firebaseConfig } from "../../config/config";

export default firebase.initializeApp(firebaseConfig);
// if (process.env.REACT_APP_STAGE === 'dev')  firebase.auth().useEmulator('http://localhost:9099/');
export const database = firebase.database();
export const auth = firebase.auth();
